module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-fef89e685391423f6f3af0797729a9c2.png";